module.exports = __webpack_public_path__ + "media/packs/images/flags/MY-157b414f0715d8d289f59564ba035281.svg";